import * as React from 'react';
import { useDrag } from 'react-dnd';
import { ItemTypes } from './ItemTypes';
import './Pawn.css';

const Pawn = ({ pawnId, game }) => {
    const [{ isDragging }, drag] = useDrag(() => ({
        type: ItemTypes.PAWN,
        collect: (monitor) => ({
            isDragging: !!monitor.isDragging()
        })
    }));

    return (
        <div className={`pawn ${isDragging ? 'selected' : ''}`} onPointerDown={() => game.setSelectedPawn(pawnId)} ref={drag}></div>
    );
}

export default Pawn;